<app-dialog-header label="{{this.NomFitxer}}" i18n-label></app-dialog-header>
<div class="text-center">
  <img  src='{{this.imgData}}' class="img-fluid"  style="vertical-align: middle;" />
</div>
